'use client';

import { OutcomeTabs } from '@/lib/components/Outcomes/OutcomeTabs';
import { MarketItem } from '@/lib/types/markets/market';

type OutcomeTabsWrapperProps = {
  outcome: MarketItem;
  showChartTab?: boolean;
  showPositionsTabs?: boolean;
  hideOrderBookTab?: boolean; // Hide Order Book tab if it's displayed separately
  isEventConcluded?: boolean;
  className?: string;
};

/**
 * Wrapper component for a single outcome tabs
 * TradingDataProvider is now at page level
 */
export const OutcomeTabsWrapper = ({
  outcome,
  showChartTab = false,
  showPositionsTabs = false,
  hideOrderBookTab = false,
  isEventConcluded = false,
  className,
}: OutcomeTabsWrapperProps) => {
  return (
    <OutcomeTabs
      outcome={outcome}
      showChartTab={showChartTab}
      showPositionsTabs={showPositionsTabs}
      hideOrderBookTab={hideOrderBookTab}
      isEventConcluded={isEventConcluded}
      className={className}
    />
  );
};
